module.exports = __webpack_public_path__ + "media/images/cms/img_slide_01-e98bc6c6e77c0e4a9ab5b97e697fa312.jpg";